module.exports = __webpack_public_path__ + "static/banner-9e45dc8f9adfff27b668897976c09ce4.png";